import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Alert, Row, Col, InputGroup } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import axios from 'axios';
import { countryCodes } from '../../../shared/utils/country';
import { CashStack, ListUl, PlusCircle } from 'react-bootstrap-icons';
import './PriceManagement.css'; // Import new CSS file

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

const PriceManagement = () => {
    const [prices, setPrices] = useState([]);
    const [newPrice, setNewPrice] = useState({
        country_code: '',
        subscription_type: 'monthly',
        price: '',
        currency: 'USD'
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const fetchPrices = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/admin/pricing`);
            setPrices(response.data);
        } catch (err) {
            setError('Failed to fetch prices.');
            console.error('Error fetching prices:', err);
        }
    };

    useEffect(() => {
        fetchPrices();
    }, []);

    const handleNewPriceChange = (e) => {
        const { name, value } = e.target;
        setNewPrice(prev => ({ ...prev, [name]: value }));
    };

    const handleAddPrice = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        try {
            await axios.post(`${API_BASE_URL}/api/admin/pricing`, newPrice);
            setSuccess('Successfully added new price.');
            setNewPrice({ country_code: '', subscription_type: 'monthly', price: '', currency: 'USD' });
            fetchPrices(); // Refresh the list
        } catch (err) {
            setError('Failed to add new price.');
            console.error('Error adding price:', err);
        }
    };

    return (
        <div>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}

            <Card className="mb-4 price-management-card">
                <Card.Header className="d-flex align-items-center">
                    <CashStack className="me-2" />
                    <h5 className="mb-0">Add New Price</h5>
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleAddPrice}>
                        <Row className="g-3">
                            <Col md={3}>
                                <Form.Group controlId="formCountryCode" className="form-floating">
                                    <Form.Select name="country_code" value={newPrice.country_code} onChange={handleNewPriceChange} required>
                                        <option value="">Select Country</option>
                                        {countryCodes.map(country => (
                                            <option key={country.code} value={country.code}>
                                                {country.name} ({country.code})
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Label>Country Code</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="formSubscriptionType" className="form-floating">
                                    <Form.Select name="subscription_type" value={newPrice.subscription_type} onChange={handleNewPriceChange}>
                                        <option value="monthly">Monthly</option>
                                        <option value="yearly">Yearly</option>
                                    </Form.Select>
                                    <Form.Label>Subscription Type</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="formPrice" className="form-floating">
                                    <Form.Control type="number" name="price" value={newPrice.price} onChange={handleNewPriceChange} placeholder="e.g., 9.99" required />
                                    <Form.Label>Price ({newPrice.currency})</Form.Label>
                                </Form.Group>
                            </Col>
                            <Col md={3} className="d-flex align-items-end">
                                <Button type="submit" className="w-100">
                                    <PlusCircle className="me-2" />Add Price
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>

            <Card className="price-management-card">
                <Card.Header className="d-flex align-items-center">
                    <ListUl className="me-2" />
                    <h5 className="mb-0">Existing Prices</h5>
                </Card.Header>
                <Card.Body>
                    <Table striped bordered hover responsive className="mt-3 expense-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Country Code</th>
                                <th>Subscription Type</th>
                                <th>Price</th>
                                <th>Currency</th>
                            </tr>
                        </thead>
                        <tbody>
                            {prices.map(price => (
                                <tr key={price.id}>
                                    <td>{price.id}</td>
                                    <td>{price.country_code}</td>
                                    <td>{price.subscription_type}</td>
                                    <td>{price.price}</td>
                                    <td>{price.currency}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </div>
    );
};

export default PriceManagement;
